import { DEFAULT_TOTAL_RECORDS } from "utils/constants";
import zoneLocalStorageId from "utils/zone";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchPatientAppointment = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );
  const sub_franchise = Number(localStorage.getItem("sub_franchise"));

  let params = {
    limit,
    page_no,
    zone_id: zoneLocalStorageId(),
    ...filter,
  };

  if (
    f_is_franchise_employee === 1
      ? true
      : f_is_super_franchise === 1
      ? true
      : sub_franchise === 1
      ? true
      : false
  ) {
    params = {
      ...params,
      f_is_franchise_employee,
      f_franchise_id,
      f_is_super_franchise,
    };
  }

  return axiosInstance.get(EndPoints.PatientAppointmentDetails.LIST, {
    params,
  });
};

export const createPatientAppointment = (payload) => {
  return axiosInstance.post(
    EndPoints.PatientAppointmentDetails.CREATE,
    payload
  );
};

export const changeFranchise = (payload) => {
  return axiosInstance.post(
    EndPoints.PatientAppointmentDetails.CHANGE_FRANCHISE,
    payload
  );
};

export const changeBarcode = (payload) => {
  return axiosInstance.post(
    EndPoints.PatientAppointmentDetails.CHANGE_BARCODE,
    payload
  );
};

export const getSampleWiseBarcode = (payload) => {
  const url = `${EndPoints.PatientAppointmentDetails.GET_SAMPLEWISE_BARCODE}?appointment_id=${payload}`;
  return axiosInstance.post(url);
};

export const createPatientSettlement = (payload) => {
  return axiosInstance.post(EndPoints.PatientSettlement.CREATE, payload);
};

// export const fetchPatientReceiptData = (payload) => {
//   const { appointment_id } = payload;
//   return axiosInstance.get(EndPoints.PatientReceipt.LIST, {
//     params: {
//       appointment_id,
//       zone_id,
//     },
//   });
// };

export const fetchPatientReceiptData = (payload) => {
  const { appointment_id } = payload;
  console.log("appointment_id", appointment_id);
  return axiosInstance.get(
    `${EndPoints.PatientReceipt.LIST}/${appointment_id}`,
    {
      params: { zone_id },
    }
  );
};

export const updatePatientAppointment = (payload) => {
  return axiosInstance.put(EndPoints.PatientAppointmentDetails.UPDATE, payload);
};

export const deletePatientAppointment = (payload) => {
  const url = EndPoints.PatientAppointmentDetails.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadCSV = () => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );
  return axiosInstance.put(
    `${
      EndPoints.PatientAppointmentDetails.DOWNLOAD_CSV
    }?zone_id=${zoneLocalStorageId()}&f_is_franchise_employee=${f_is_franchise_employee}&f_franchise_id=${f_franchise_id}&f_is_super_franchise=${f_is_super_franchise}`,
    {},
    {
      responseType: "blob",
    }
  );
};

export const updatePatientCancellationAppointment = (payload) => {
  return axiosInstance.put(
    EndPoints.PatientAppointmentDetails.CANCELLATION,
    payload
  );
};
